import React, { useState } from 'react';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { useAuth } from '../../contexts/auth.context';
import ConsumeFragmentsModal from './ConsumeFragmentsModal';

const AdminConsumeFragments = () => {
  const { auth } = useAuth();
  const [walletId, setWalletId] = useState('');
  const [reason, setReason] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [request, setRequest] = useState(null);

  const trimmedWalletId = walletId.trim();

  const handleSubmit = event => {
    event.preventDefault();

    if (!trimmedWalletId) {
      return;
    }

    setRequest({
      walletId: trimmedWalletId,
      reason: reason.trim(),
    });
    setShowModal(true);
  };

  return (
    <Container fluid className="py-4 px-4 overflow-auto vh-100">
      <Row className="justify-content-center">
        <Col xl={7} lg={8}>
          <Card className="shadow-sm">
            <Card.Body className="p-4">
              <div className="mb-4">
                <h4 className="mb-2">Consume Points</h4>
                <p className="mb-0 text-body-secondary">
                  Drain a wallet&apos;s points balance. Add an optional reason when you need extra
                  audit trail context for the consume request.
                </p>
              </div>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="fragmentWalletId" className="mb-3">
                  <Form.Label>Wallet ID</Form.Label>
                  <Form.Control
                    type="text"
                    value={walletId}
                    onChange={event => setWalletId(event.target.value)}
                    placeholder="Enter the target wallet ID"
                    autoComplete="off"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="fragmentReason" className="mb-4">
                  <Form.Label>Reason</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={reason}
                    onChange={event => setReason(event.target.value)}
                    placeholder="Optional reason for the audit trail"
                  />
                </Form.Group>

                <Button type="submit" disabled={!trimmedWalletId}>
                  Consume Points
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <ConsumeFragmentsModal
        show={showModal}
        request={request}
        token={auth?.idToken}
        onHide={() => setShowModal(false)}
      />
    </Container>
  );
};

export default AdminConsumeFragments;
